const SemanticAccordionSchema = {
  title: 'Accordion (Semantic UI)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'styled', 
        'fluid', 
        'exclusive', 
        'wrapped', 
        'inverted', 
        'items'
      ],
    },
  ],

  properties: {
    styled: {
      title: 'Styled',
      description: 'Adds basic styling to panels',
      type: 'boolean',
      default: true,
    },
    fluid: {
      title: 'Fluid',
      description: 'Takes up the width of the container',
      type: 'boolean',
      default: true,
    },
    exclusive: {
      title: 'Exclusive',
      description: 'Displays only one at a time',
      type: 'boolean',
      default: true,
    },
    wrapped: {
      title: 'Wrapped',
      type: 'boolean',
      description: 'Wraps the component in a Semantic UI Segment',
      default: false,
    },

    items: {
      title: 'Accordion Items',
      widget: 'object_list',
      schema: {
        title: 'Item',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['title', 'content'],
          },
        ],
        properties: {
          title: {
            title: 'Title',
            type: 'string',
          },
          content: {
            title: 'Content',
            widget: 'textarea',
            type: 'string',
          },
        },
        required: [],
      },
    },
  },

  required: ['items'],
};

export default SemanticAccordionSchema;